import { ApiEntity, Entity } from './common.types'

// TODO: Use updated date-fns
export function parseApiEntityData<T extends ApiEntity>({
  createdAt,
  updatedAt,
  ...otherData
}: T): Omit<T, 'createdAt' | 'updatedAt'> & { createdAt?: Date; updatedAt?: Date } {
  return {
    createdAt: createdAt ? new Date(createdAt) : undefined,
    updatedAt: updatedAt ? new Date(updatedAt) : undefined,
    ...otherData,
  }
}

export function parseEntityToApiData({ createdAt, updatedAt, ...otherData }: Entity): ApiEntity {
  return otherData
}
